var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKidneyHealth = function SvgKidneyHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M10.06 7.08c0 1.852-1.843 1.86-1.843 3.381 0 .948.924 1.236 1.669 1.264-.756-.007-1.412.11-1.67.697-.358.82.466 1.187.466 2.575s-1.206 1.97-2.353 1.97c-1.146 0-4.007-1.299-4.007-6.074S5.295 4.5 7.044 4.5s3.016.845 3.016 2.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.07 20.5v-7.814a.973.973 0 0 0-.975-.955"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14.58 7.08c0 1.852 1.842 1.86 1.842 3.381 0 .948-.925 1.236-1.67 1.264.756-.007 1.413.11 1.67.697.359.82-.465 1.187-.465 2.575s1.206 1.97 2.352 1.97c1.147 0 4.007-1.299 4.007-6.074S19.344 4.5 17.594 4.5s-3.015.845-3.015 2.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.57 20.5v-7.814c0-.461.383-.955.974-.955"
  }))));
};
export default SvgKidneyHealth;